import { store } from "../store";
import { PermissionEnum } from "../../scripts/repositories";
import { confirm } from 'devextreme/ui/dialog';

export function isReadOnly(editPermissions) {

    var x = store.getters;
    var storePermissions = x["account/permissions"];

    if (storePermissions.includes(PermissionEnum.ReadOnlyUser) && !storePermissions.includes(PermissionEnum.Administrator))
        return true;

    if (editPermissions == null)
        return false;

    for (var i = 0; i < editPermissions.length; i++) {
        if (storePermissions.includes(editPermissions[i]) ||
            (storePermissions.includes(PermissionEnum.Administrator) && editPermissions[i] > 0))
            continue;

        return true;
    }

    return false;
}

export function isReadOnlyUser() {

    var x = store.getters;
    var storePermissions = x["account/permissions"];

    if (storePermissions.includes(PermissionEnum.ReadOnlyUser) && !storePermissions.includes(PermissionEnum.Administrator))
        return true;
    else
        return false;
}

export function createEmptyDataSource(editPermissions) {

    var readOnly = false;

    if (editPermissions != null) {
        var x = store.getters;
        var storePermissions = x["account/permissions"];

        if (storePermissions.includes(PermissionEnum.ReadOnlyUser) && !storePermissions.includes(PermissionEnum.Administrator))
            return true;


        for (var i = 0; i < editPermissions.length; i++) {
            if (storePermissions.includes(editPermissions) ||
                (storePermissions.includes(PermissionEnum.Administrator) && editPermissions[i] > 0))
                continue;

            readOnly = true;
            break;
        }
    }

    var ds = {
        id: null,
        blo: {},
        bloOriginal: {},
        bloOriginalJSON: "",
        isDataLoaded: false,
        readOnly: readOnly,
        bloValueChangesCount: 0,
        afterSaveMessage: "",
        saveStatusIndicator: 0, //0 nothing,1-star,2-saved
        bloValueChanged: function () {
            this.bloValueChangesCount++;
            this.saveStatusIndicator = 1;
            window.___GOP.dataModified = true;
        },
        resetbloValueChangesCount: function () {
            this.bloValueChangesCount = 0;
            window.___GOP.dataModified = false;
            if (this.saveStatusIndicator == 1)
                this.saveStatusIndicator = 0;
        },
        resetBasedOnBlo(bloOriginalJSON) {
            if (bloOriginalJSON == JSON.stringify(this.blo)) {
                this.resetbloValueChangesCount();
            }
        },
        afterSave: function () {
            this.afterSaveMessage = " - data saved";
            this.saveStatusIndicator = 2;
            var _this = this;
            setTimeout(function () {
                _this.afterSaveReset(_this);
            }, 1000);
        },
        afterSaveReset: function (_this) {
            _this.afterSaveMessage = "";
            if (_this.bloValueChangesCount == 0)
                _this.saveStatusIndicator = 0;
        },
        askModified: function () {
            if (this.bloValueChangesCount > 0) {
                var result = confirm("Do you really want to leave without saving your changes?", "You have unsaved changes!");
                result.done(function (dialogResult) {
                    return dialogResult;
                });
                return Promise.resolve(result);
            }
        }
    }

    return ds;
}

